import { render, staticRenderFns } from "./OfferBookingSection.vue?vue&type=template&id=6ff66bea"
import script from "./OfferBookingSection.vue?vue&type=script&lang=js"
export * from "./OfferBookingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports